module.exports = __webpack_public_path__ + "img/arrow-back.1d90cfbb.svg";